import React, { useState } from "react";
import moment from "moment";
import { Table } from "antd";

const EmiCalculator = () => {
  const [formData, setFormData] = useState({
    principal: "",
    fileCharges: "",
    otherCharges: "",
    term: "",
    interestRate: "",
    startDate: "",
    emiType: "flat", // added emi type
  });

  const [schedule, setSchedule] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const calculateEMI = () => {
    const P = parseFloat(formData.principal);
    const FC = parseFloat(formData.fileCharges);
    const OC = parseFloat(formData.otherCharges);
    const N = parseInt(formData.term);
    const R = parseFloat(formData.interestRate) / 12 / 100;
    const startDate = moment(formData.startDate);
    const emiType = formData.emiType;

    const totalPrincipal = P + FC + OC;
    let scheduleData = [];

    if (emiType === "flat") {
      const totalInterest = totalPrincipal * (parseFloat(formData.interestRate) / 100) * (N / 12);
      const emi = (totalPrincipal + totalInterest) / N;
      for (let i = 0; i < N; i++) {
        const interest = totalInterest / N;
        const principalComponent = totalPrincipal / N;
        scheduleData.push({
          key: i + 1,
          srNo: i + 1,
          principalAmount: principalComponent.toFixed(2),
          interestAmount: interest.toFixed(2),
          emiAmount: emi.toFixed(2),
          dueDate: moment(startDate).add(i, "months").format("DD-MM-YYYY"),
          total: emi.toFixed(2),
        });
      }
    } else {
      const emi =
        R === 0 ? totalPrincipal / N : (totalPrincipal * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);
      let balance = totalPrincipal;
      for (let i = 0; i < N; i++) {
        const interest = balance * R;
        const principalComponent = emi - interest;
        balance -= principalComponent;
        scheduleData.push({
          key: i + 1,
          srNo: i + 1,
          principalAmount: principalComponent.toFixed(2),
          interestAmount: interest.toFixed(2),
          emiAmount: emi.toFixed(2),
          dueDate: moment(startDate).add(i, "months").format("DD-MM-YYYY"),
          total: (principalComponent + interest).toFixed(2),
        });
      }
    }

    setSchedule(scheduleData);
  };

  const columns = [
    { title: "Sr. No.", dataIndex: "srNo" },
    { title: "Principal Amount", dataIndex: "principalAmount" },
    { title: "Interest Amount", dataIndex: "interestAmount" },
    { title: "EMI Amount", dataIndex: "emiAmount" },
    { title: "Due Date", dataIndex: "dueDate" },
    { title: "Total", dataIndex: "total" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h4>EMI Calculator</h4>
          </div>

          <div className="card-body">
            <div className="row g-3">
              {[
                { label: "Principal Amount", name: "principal" },
                { label: "File Charges", name: "fileCharges" },
                { label: "Other Charges", name: "otherCharges" },
                { label: "Term (Months)", name: "term" },
                { label: "Rate of Interest (%)", name: "interestRate" },
                { label: "EMI Start Date", name: "startDate", type: "date" },
              ].map((input) => (
                <div className="col-md-4" key={input.name}>
                  <label>{input.label}</label>
                  <input
                    type={input.type || "number"}
                    className="form-control"
                    name={input.name}
                    value={formData[input.name]}
                    onChange={handleChange}
                  />
                </div>
              ))}

              <div className="col-md-4">
                <label>EMI Type</label>
                <select
                  name="emiType"
                  className="form-control"
                  value={formData.emiType}
                  onChange={handleChange}
                >
                  <option value="flat">Flat</option>
                  <option value="reducing">Reducing</option>
                </select>
              </div>

              <div className="col-12">
                <button className="btn btn-success mt-2" onClick={calculateEMI}>
                  Calculate EMI Schedule
                </button>
              </div>
            </div>

            <div className="table-responsive mt-4">
              <Table
                columns={columns}
                dataSource={schedule}
                pagination={{ pageSize: 12 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmiCalculator;
